import api from './../libs/api';

export default {
  getSearchLogs: async (dateRange = null) => {
    try {
      let url = `/logs/search`;
      
      if (dateRange && dateRange.length === 2) {
        const [startDate, endDate] = dateRange;
        url += `?start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
      }
      
      const response = await api().get(url);
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },
  
  getClickLogs: async (dateRange = null) => {
    try {
      let url = `/logs/click`;
      
      if (dateRange && dateRange.length === 2) {
        const [startDate, endDate] = dateRange;
        url += `?start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
      }
      
      const response = await api().get(url);
      return response.data || [];
    } catch (error) {
      throw error;
    }
  },

  logClick: (companyId) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/logs/click`, { company_id: companyId })
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },
}; 